import React, { useState, useEffect } from 'react';

const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };
const font = "'DM Sans', sans-serif";

export default function InstallBanner() {
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Only show on mobile devices
    const mobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent) || window.innerWidth < 768;
    if (!mobile) return;

    // Don't show if already installed or dismissed
    if (localStorage.getItem('td_install_dismissed')) return;
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    if (ios) {
      setTimeout(() => setShow(true), 5000);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    dismiss();
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem('td_install_dismissed', 'true');
  };

  if (!show) return null;

  return (
    <div style={{
      position:'fixed', bottom:0, left:0, right:0, zIndex:300,
      background:'#fff', borderTop:'0.5px solid #e8e8e8',
      padding:'12px 16px', display:'flex', alignItems:'center', gap:12,
      boxShadow:'0 -4px 20px rgba(0,0,0,0.08)',
    }}>
      <div style={{ width:36, height:36, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
        <span style={{ color:'#fff', fontSize:11, fontWeight:600 }}>T&D</span>
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <p style={{ fontSize:13, fontWeight:500, margin:0, fontFamily:font }}>Instala T&D en tu teléfono</p>
        <p style={{ fontSize:11, color:'#999', margin:0, fontFamily:font }}>
          {isIOS ? 'Toca compartir ⬆ y luego "Agregar a inicio"' : 'Mejor experiencia como app'}
        </p>
      </div>
      {!isIOS && (
        <button onClick={install} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'8px 16px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font, whiteSpace:'nowrap' }}>
          Instalar
        </button>
      )}
      <button onClick={dismiss} style={{ background:'none', border:'none', color:'#999', fontSize:18, cursor:'pointer', padding:'0 4px' }}>×</button>
    </div>
  );
}
